import { ApiService } from "./api.service";
import { Injectable } from "@angular/core";
import { AppConfig } from "../Utilities/app-config.service";
import { ReferralSearchEntityModel, ReferralCommissionModel } from '../models/referral-management-model';

@Injectable({
  providedIn: "root"
})
export class ReferralService {
  constructor(
    private _apiService: ApiService,
    private _appConfig: AppConfig
  ) {}

  saveReferral(body: any) {

    return this._apiService.post(this._appConfig.GetUrl("saveReferral"), body);
  }

  getReferral(referralSearchEntityModel: ReferralSearchEntityModel) {

    return this._apiService.post(this._appConfig.GetUrl('getReferral'), referralSearchEntityModel);
  }

  getReferralDetails(id) {

    return this._apiService.get(this._appConfig.GetUrl('getReferralDetails') + id);
  }

  updateReferralCommission(referralCommissionModel: ReferralCommissionModel) {

    let endPoitURL = this._appConfig.GetUrl('updateReferralCommission');
    endPoitURL = endPoitURL.toString().replace('REFID',referralCommissionModel.ReferralID);

    return this._apiService.put(endPoitURL, referralCommissionModel);
  }
}
